<script module lang="ts">
  import type { SupabaseClient } from '@supabase/supabase-js';
  import { getContext } from 'svelte';

  const supabaseKey = Symbol('supabase');
  export const useSupabaseClient = () =>
    getContext<{ readonly client: SupabaseClient }>(supabaseKey).client;
</script>

<script lang="ts">
  import { setContext } from 'svelte';
  import type { Snippet } from 'svelte';

  const { client, children }: { client: SupabaseClient; children: Snippet } = $props();
  setContext(supabaseKey, { get client() { return client; } });
</script>

{@render children()}
